document.addEventListener('DOMContentLoaded', function() {
  $('.reviews--slider').on('init', function (event, slick) {
    changeProgressBar(slick, 0);
  });

  $('.reviews--slider').slick({
    infinite: false,
    arrows: true,
    slidesToShow: 3.03,
    slidesToScroll: 1,
    rows: 0,
    prevArrow: '<div class="reviews__prevArrow"></div>',
    nextArrow: '<div class="reviews__nextArrow"></div>',
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1.25,
          arrows: false
        }
      }
    ]
  });

  $('.reviews--slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    changeProgressBar(slick, nextSlide);
  });


  function changeProgressBar(slick, nextSlide) {
    let calc = ((nextSlide + 1) / (slick.slideCount - 2)) * 100;
    let progressBar = $('.reviews__progress');

    if(window.outerWidth <= 640) {
      calc = ((nextSlide + 1) / (slick.slideCount)) * 100;
    }

    progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  }
});
